import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[appGalleryViewOrdered]'
  })
export class GalleryViewOrderedDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
